<template>
    <b-modal :id="modalId" size="xl" :title="isVideo ? 'Preview Video' : 'Preview Foto'">
        <slot name="header" />
        <div class="modal-foto-wrapper">
            <ImageCard
                v-if="withRotate"
                :key="fotoPreview"
                :src="fotoPreview" 
                :title="'Foto'"
                @preview="openPreview"
            />
            <video v-else-if="isVideo" :src="fotoPreview" controls style="max-width: 100%;"></video>
            <img v-else :src="fotoPreview" alt="Foto">
        </div>
        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                Close
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import ImageCard from '@/components/common/ImageCard'

export default {
    name: 'modal-preview-foto',
    components: {
        ImageCard,
    },
    props: {
        fotoPreview: { type: String, required: true },
        modalId: { type: String, default: "modal-preview-foto" },
        withRotate: { type: Boolean, default: false },
        isVideo: { type: Boolean, default: false }
    },
    methods: {
        openPreview(url) {
            window.open(url, '_blank')
        }
    }
}
</script>